import React from 'react';
import { Wrench } from 'lucide-react';
export function Process() {
  const steps = [{
    title: 'Request Your Free In-Home Quote',
    copy: "Submit the short form or call Kosin's Glass."
  }, {
    title: 'Share Photos & Basic Details',
    copy: 'A team member will ask about your bathroom layout, existing shower or tub opening, project timeline, rough measurements and style preferences.'
  }, {
    title: 'In-Home Consultation & Samples',
    copy: "Kosin's Glass can come to your home, review the space, show samples, discuss glass options and recommend the right enclosure style."
  }, {
    title: 'Exact Measurements & Firm Quote',
    copy: 'Exact measurements are taken before fabrication. Your final quote should reflect the measurements, glass selection, hardware finish and installation requirements.'
  }, {
    title: 'Fabrication & Professional Installation',
    copy: 'Your custom shower glass is prepared, then installed by experienced glass technicians with attention to fit, finish, function and long-term appearance.'
  }];
  return <section className="py-20 bg-glass" data-id="element-1634">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1635">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1636">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-1637">
            How Your Custom Shower Door Quote Works
          </h2>
        </div>
        <div className="grid lg:grid-cols-12 gap-12 items-start" data-id="element-1638">
          <div className="lg:col-span-8" data-id="element-1639">
            <div className="space-y-8" data-id="element-1640">
              {steps.map((step, i) => <div key={i} className="flex gap-6 bg-white p-6 rounded-2xl shadow-sm border border-blue-50 scroll-fade-up" style={{
              animationDelay: `${i * 0.1}s`
            }} data-id="element-1641">
                  <div className="w-12 h-12 shrink-0 bg-primary text-white rounded-full flex items-center justify-center text-xl font-bold" data-id="element-1642">
                    {i + 1}
                  </div>
                  <div data-id="element-1643">
                    <h3 className="text-xl font-bold text-navy mb-2" data-id="element-1644">
                      {step.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-1645">{step.copy}</p>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="lg:col-span-4" data-id="element-1646">
            <div className="bg-navy text-white p-8 rounded-3xl sticky top-8 scroll-fade-up" data-id="element-1647">
              <h4 className="text-xl font-bold mb-4 flex items-center gap-2" data-id="element-1648">
                <Wrench className="w-6 h-6 text-primary" data-id="element-1649" />
                Remodeling tip
              </h4>
              <p className="text-blue-100 leading-relaxed" data-id="element-1650">
                If your bathroom is being remodeled, contact Kosin's Glass early
                for planning help. Final shower glass measurements are typically
                best after tile, walls and curb details are complete.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}